import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../myTrack/AuthContext';
import { rootUrl } from '../../config/config';

const usePermissions = () => {
    const { token } = useAuth();
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) {
            setPermissions([]);
            setLoading(false);
            return undefined;
        }

        let cancelled = false;

        const fetchPermissions = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${rootUrl}/api/users/me/permissions`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (!cancelled) {
                    setPermissions(response.data?.data || []);
                }
            } catch (error) {
                if (!cancelled) {
                    setPermissions([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchPermissions();

        return () => {
            cancelled = true;
        };
    }, [token]);

    const hasPermission = useCallback((permissionKey) => {
        if (!permissionKey) return true;
        return permissions.includes(permissionKey);
    }, [permissions]);

    return { permissions, loading, hasPermission };
};

export default usePermissions;
